import { render, staticRenderFns } from "./SelectGroupeStatsComponent.vue?vue&type=template&id=384c566d&scoped=true"
import script from "./SelectGroupeStatsComponent.vue?vue&type=script&lang=js"
export * from "./SelectGroupeStatsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384c566d",
  null
  
)

export default component.exports